import { Popper } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekPopper = styled(Popper)(({ theme }) => ({}));

export { PeekPopper, PeekPopper as default };
